import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CloseIconComponent } from '../icons/close-icon.component';

export interface InvoicePreviewDialogData {
  url: string;
  isImage: boolean;
  fileName?: string;
}

@Component({
  selector: 'app-invoice-preview-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, CloseIconComponent],
  template: `
    <div class="relative flex flex-col items-center justify-center w-full h-full">
      <div class="absolute top-2 right-2 z-10 flex gap-2">
        <button class="w-10 h-10 flex items-center justify-center rounded-full bg-black/50 hover:bg-black/70 transition-colors" (click)="download()">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24">
            <path fill="white" d="M12 15.575q-.2 0-.375-.062T11.3 15.3l-3.6-3.6q-.275-.275-.275-.7t.275-.7t.713-.288t.712.288L11 12.175V5q0-.425.288-.712T12 4t.713.288T13 5v7.175l1.875-1.875q.275-.275.713-.288t.712.288q.275.275.275.7t-.275.7l-3.6 3.6q-.15.15-.325.213t-.375.062M6 20q-.825 0-1.412-.587T4 18v-2q0-.425.288-.712T5 15t.713.288T6 16v2h12v-2q0-.425.288-.712T19 15t.713.288T20 16v2q0 .825-.587 1.413T18 20z"/>
          </svg>
        </button>
        <button class="w-10 h-10 flex items-center justify-center rounded-full bg-black/50 hover:bg-black/70 transition-colors" (click)="close()">
          <app-close-icon class="text-white" [size]="'22'"></app-close-icon>
        </button>
      </div>
      @if (data.isImage) {
        <img
          [src]="data.url"
          alt="Factura"
          class="max-w-full max-h-[85vh] object-contain rounded-lg"
        />
      } @else {
        <iframe
          [src]="safeUrl"
          class="w-full h-full rounded-lg"
          style="min-height: 80vh;"
        ></iframe>
      }
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
      height: 100%;
    }
  `]
})
export class InvoicePreviewDialogComponent {
  safeUrl: SafeResourceUrl;

  constructor(
    public dialogRef: MatDialogRef<InvoicePreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InvoicePreviewDialogData,
    private sanitizer: DomSanitizer
  ) {
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.validatePreviewUrl(data.url));
  }

  close() {
    this.dialogRef.close();
  }

  download() {
    const a = document.createElement('a');
    a.href = this.data.url;
    a.download = this.data.fileName || 'factura';
    document.body.appendChild(a);
    try {
      a.click();
    } finally {
      document.body.removeChild(a);
    }
  }

  private validatePreviewUrl(url: string): string {
    if (!url.startsWith('blob:')) {
      throw new Error('Invalid invoice preview URL.');
    }
    return url;
  }
}
